import { PostCustomerAccountReadPtaTotalListApiForm } from "../../pages/customer/correspondent/detail/interface";
import { AccountSearchInterface } from "../../pages/customer/correspondent/list/interface/searchInterface";
import { PTATierResType } from "../../pages/customer/tier/interface";
import {
  DefaultResType,
  ErrorType,
  ResponseResType,
} from "../../types/common/response";
import { baseApi } from "../../util/axiosConfig";

/**
 * pta tier 관리
 */
const url = "api/customer/ptaTier/";

/**
 * PTA 티어 리스트
 * @param data
 * @returns
 */
export async function readPtaTierListApi(
  data: AccountSearchInterface
): Promise<
  ResponseResType<{ totalCount: number; list: PTATierResType[] }> | ErrorType
> {
  const response = await baseApi.post(url + "read_pta_tier_list", data);
  return response?.data;
}

/**
 * PTA 티어 excel 내보내기
 * @param data
 * @returns
 */
export async function exportPtaTierExcelApi(
  data: AccountSearchInterface
): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
  const response = await baseApi.post(url + "export_pta_tier_excel", data, {
    responseType: "blob",
  });

  return response?.data;
}

/**
 * PTA 티어 excel 가져오기
 * @param formData
 * @returns
 */
export async function uploadPtaTierExcelApi(
  formData: FormData
): Promise<DefaultResType | ErrorType> {
  const response = await baseApi.post(url + "upload_pta_tier_excel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response?.data;
}

export async function postCustomerAccountReadPtaTotalListApi( // PTA 티어 검색
  data: PostCustomerAccountReadPtaTotalListApiForm
): Promise<any> {
  const response = await baseApi.post("api/customer/account/read_pta_total_list", data);
  return response?.data;
}